import React, { ReactElement } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { Langue } from '../../../../../common/src/entities';

/**
 * Afficher les champs de langage
 * @returns un champ de langue
 */
export function ChampLangue(): ReactElement {
    return <ChampFormulaire id="name" titre="Nom" />;
}

/**
 * Affiche un popup pour confirmer la création de la nouvelle langue.
 * @param props props de creation entité
 * @returns un popup pour créer langue
 */
export default function CreerLangue(props: Partial<PropsDeCreationEntite<Langue>>): ReactElement {
    return (
        <FormulaireCreationEntite
            texteEntete={(t: Langue) => (
                <>
                    <small className="text-muted">Modifier</small>&nbsp;{t.name}
                </>
            )}
            entite={Langue}
            noSave
            {...props}
        >
            <ChampLangue />
        </FormulaireCreationEntite>
    );
}
